<template>
  <v-app>
    <v-content>
      <TheHeader/>
      <TheWhy/>
      <TheHow/>
      <TheWhat/>
      <HeIs/>
      <Contact id="kontakt"/>
      <TheFooter/>
    </v-content>
  </v-app>
</template>

<script>
import TheHeader from './components/TheHeader'
import TheWhy from './components/TheWhy'
import TheHow from './components/TheHow'
import TheWhat from './components/TheWhat'
import HeIs from './components/HeIs'
import Contact from './components/Contact'
import TheFooter from './components/TheFooter'

export default {
  name: 'App',

  components: {
    TheHeader,
    TheWhy,
    TheHow,
    TheWhat,
    HeIs,
    Contact,
    TheFooter
  },

  data: () => ({
    //
  })
}
</script>

<style lang="scss">
  .theme--light.v-text-field > .v-input__control > .v-input__slot::before {
    border: 1px solid #F49E00 ;
  }

  .v-text-field > .v-input__control > .v-input__slot::after {
    border-color: #F49E00;
  }

  .theme--light.v-text-field:not(.v-input--has-state):hover > .v-input__control > .v-input__slot::before {
    border-color: #F49E00;
  }

  .v-application .primary--text {
    color: #F49E00 !important;
  }

  // Setting Max width for content
  .row {
    max-width: 1035px;
    margin: 0 auto;
    width: 100%;
  }

  // Setting max width for smaller rows
  .smaller-row-width {
    max-width: 850px;
    width: 100%;
  }

  // Setting Row Max width
  .max-row-790 {
    max-width: 790px;
    margin-left: 113px;
    width: 100%;
  }

  // Setting Max Content for 2 Layer Layout
  .max-650 {
    max-width: 650px;
    width: 100%;
  }

  // Setting Max Content for 2 Layer Layout inside a container
  .max-520 {
    max-width: 520px;
    width: 100%;
  }

  // Setting BG Image
  .einstieg {
    background-image: url('/images/RaabCoaching_gespiegelt.jpg');
    background-size: cover;
    background-position: top left;
  }

  .v-btn__content {
    flex-direction: column !important;
  }

  // Basic Global Element Setup
  h1 {
    font-family: $second-font-family;
    font-size: 2.5rem;
    font-weight: 500;
    font-style: normal;
    line-height: 1.16;
    color: $white;
    margin-left: 2em;
  }

  p {
    font-family: $body-font-family;
    font-size: 1rem;
    font-weight: 400;
    line-height: 1.56;
    letter-spacing: .18px;
    color: $white;

    &.text-yellow {
      font-family: $second-font-family;
      font-size: .944rem;
      font-weight: 700;
      line-height: 1.47;
      letter-spacing: .17px;
      color: $orange-yellow;
      max-width: 230px;
      float: right;
    }

    &.text-blue {
      font-family: $second-font-family;
      font-size: .944rem;
      font-weight: 700;
      line-height: 1.47;
      letter-spacing: .17px;
      color: $dark-grey-blue;
      max-width: 230px;
      float: right;
    }

    &.text-blue-light {
      font-family: $second-font-family;
      font-size: .944rem;
      font-weight: 700;
      line-height: 1.47;
      letter-spacing: .17px;
      color: $sapphire;
      max-width: 230px;
      float: right;
    }
  }

  hr {
    width: 167px;
    border: solid 2px $orange-yellow;
    margin-top: 2.9rem;
    margin-bottom: 1.28rem;
  }

  // Global Responsive
  @media screen and (max-width: 1263px) {
    .max-650 {
      max-width: 100%;
   }

   .smaller-row-width {
    max-width: 1035px;
   }

    p {
      &.text-yellow,
      &.text-blue,
      &.text-blue-light {
        float: left;
      }
    }
  }

  @media screen and (max-width: 959px) {
    .max-row-790 {
      max-width: 100%;
      margin-left: 0;
    }

    .max-520 {
      max-width: 100%;
    }
  }

  @media screen and (max-width: 600px) {
    h1 {
      font-size: 1.56rem;
    }
  }
</style>
